import { Stack } from "@mui/material";
import ImageTable from "./ImageTable";
import ReportSelector from "./ReportSelector";
import ThreeTabs from "./ThreeTabs";
const VerificationPage = () => {
  const imageData = [
    {
      unitCode: "UNIT0001",
      unitName: "UNIT A",
      imgName:
        "https://img.freepik.com/free-vector/data-extraction-concept-illustration_114360-4766.jpg?t=st=1715407145~exp=1715410745~hmac=9ff9ab25aa902d5e636a0c143abbb09a43b230f903bda5147ff6b5a969111582&w=900",
    },
    {
      unitCode: "UNIT0001",
      unitName: "UNIT B",
      imgName:
        "https://img.freepik.com/free-vector/employee-working-office-interior-workplace-flat-vector-illustration_1150-37453.jpg?t=st=1715410628~exp=1715414228~hmac=609696ab589a5d7790e2e7d5a5b7868b1e528896ae75c90a3833b47275e214a2&w=740",
    },
    {
      unitCode: "UNIT0001",
      unitName: "UNIT A",
      imgName:
        "https://img.freepik.com/free-vector/data-extraction-concept-illustration_114360-4766.jpg?t=st=1715407145~exp=1715410745~hmac=9ff9ab25aa902d5e636a0c143abbb09a43b230f903bda5147ff6b5a969111582&w=900",
    },
    {
      unitCode: "UNIT0001",
      unitName: "UNIT B",
      imgName:
        "https://img.freepik.com/free-vector/employee-working-office-interior-workplace-flat-vector-illustration_1150-37453.jpg?t=st=1715410628~exp=1715414228~hmac=609696ab589a5d7790e2e7d5a5b7868b1e528896ae75c90a3833b47275e214a2&w=740",
    },
    {
      unitCode: "UNIT0001",
      unitName: "UNIT A",
      imgName:
        "https://img.freepik.com/free-vector/data-extraction-concept-illustration_114360-4766.jpg?t=st=1715407145~exp=1715410745~hmac=9ff9ab25aa902d5e636a0c143abbb09a43b230f903bda5147ff6b5a969111582&w=900",
    },
    {
      unitCode: "UNIT0001",
      unitName: "UNIT B",
      imgName:
        "https://img.freepik.com/free-vector/employee-working-office-interior-workplace-flat-vector-illustration_1150-37453.jpg?t=st=1715410628~exp=1715414228~hmac=609696ab589a5d7790e2e7d5a5b7868b1e528896ae75c90a3833b47275e214a2&w=740",
    },
    {
      unitCode: "UNIT0001",
      unitName: "UNIT A",
      imgName:
        "https://img.freepik.com/free-vector/data-extraction-concept-illustration_114360-4766.jpg?t=st=1715407145~exp=1715410745~hmac=9ff9ab25aa902d5e636a0c143abbb09a43b230f903bda5147ff6b5a969111582&w=900",
    },
    {
      unitCode: "UNIT0001",
      unitName: "UNIT B",
      imgName:
        "https://img.freepik.com/free-vector/employee-working-office-interior-workplace-flat-vector-illustration_1150-37453.jpg?t=st=1715410628~exp=1715414228~hmac=609696ab589a5d7790e2e7d5a5b7868b1e528896ae75c90a3833b47275e214a2&w=740",
    },
  ];

  return (
    <>
      <div style={{ padding: "0.5rem 4rem" }}>
        <ThreeTabs />
      </div>
    </>
  );
};
export default VerificationPage;
